import React, { useState } from "react";
import Joyride from "react-joyride";

const DemoTour = () => {
  const [run, setRun] = useState(true); // Whether to start the tour
  const steps = [
    {
      target: ".left-pane",
      content: "This is your left pane where the problem is shown.",
      disableBeacon: true,
    },
    {
      target: ".blocks-section",
      content: "These are your building blocks. Click on them to build a solution.",
      disableBeacon: true,
    },
    {
      target: ".solution-section",
      content: "Your pseudocode blocks will appear here.",
      disableBeacon: true,
    },
    {
      target: ".code-section",
      content: "Corresponding code will show in the editor.",
      disableBeacon: true,
    },
    {
      target: ".output-section",
      content: "Run your code against pre-defined test cases.",
      disableBeacon: true,
    },
  ];

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      scrollToFirstStep
      showSkipButton
      showProgress
      disableScrolling={true}
      styles={{ options: { zIndex: 10000 } }}
    />
  );
};

export default DemoTour;
